/* Bienvenida al Rincón nuevo y recorrido guiado (2026-10-21).
   Lo carga snippets/tcg-bienvenida.liquid. Sin librerías.
   - Primera visita el día del lanzamiento (21-oct): gran bienvenida a pantalla
     completa (logo, título y cinco cartas que se reparten). Del 22 al 26-oct:
     pase en una esquina que no bloquea. Desde el 27, nada. Siempre se puede saltar
     y sale una sola vez por visitante (tcgBienvenida:v2).
   - ?bienvenida=1&efecto=telon (viene del cambio de theme): se abre el telón y luego el pase.
   - /pages/arena la primera vez: aviso para un recorrido corto de la Arena.
   - [data-tcg-recorrido] en cualquier parte: abre el recorrido otra vez. */
(function () {
  'use strict';
  var tag = document.querySelector('script[data-tcg-bienvenida]');
  if (!tag) return;
  var LOGO = tag.getAttribute('data-logo') || '';
  var ARTE = tag.getAttribute('data-arte') || '';
  var EN_ARENA = tag.getAttribute('data-arena') === '1';
  var CLAVE = 'tcgBienvenida:v2', CLAVE_ARENA = 'tcgRecorridoArena:v1';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lee(k) {
    try { return localStorage.getItem(k) || sessionStorage.getItem(k); } catch (e) { return null; }
  }
  function guarda(k) {
    try { localStorage.setItem(k, '1'); } catch (e) { try { sessionStorage.setItem(k, '1'); } catch (e2) {} }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function nodo(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
  }
  function activa(on) { document.documentElement.classList.toggle('tcg-bv-activo', on); }

  // ── Pasos ──────────────────────────────────────────────────────────────
  var PASOS_TIENDA = [
    { sel: ['[data-cmd-open]'], t: 'Busca cualquier carta', p: 'Escribe el nombre o el código (por ejemplo MAMO-EN001).' + (window.matchMedia('(hover: none)').matches ? '' : ' Atajo: la tecla /.') },
    { sel: ['#HeaderMenu-tienda'], movil: true, t: 'La tienda', p: 'Singles de Yu-Gi-Oh! y Riftbound, producto sellado, accesorios y figuras, con stock real.' },
    { sel: ['#HeaderMenu-la-arena'], movil: true, t: 'La Arena', p: 'Seis juegos diarios: Adivina la carta, Yugidle, Adivina el set, El intruso, Duelo de ATK y la ruleta. Cada uno da puntos según su dificultad y el top 4 del mes gana crédito para gastar en la tienda.' },
    { sel: ['#HeaderMenu-forja-tu-deck'], movil: true, t: 'Forja tu deck', p: 'Arma tu deck carta por carta y lleva al carrito lo que te falta.' },
    { sel: ['#HeaderMenu-perfil-duelista'], movil: true, t: 'Tu Perfil Duelista', p: 'Rango, logros, títulos y marcos. Inicia sesión para que tus puntos y tus logros cuenten.' },
    { sel: ['#HeaderMenu-comunidad'], movil: true, t: 'La comunidad', p: 'Foros, intercambio entre duelistas y los torneos del Rincón.' },
    { sel: ['[data-tcg-tema]'], t: 'Modo oscuro', p: 'Cámbialo cuando quieras; la tienda recuerda tu elección.' },
    { sel: ['[data-tcg-tienda]'], scroll: true, t: 'Tienda física', p: 'Abrimos tienda física en Medellín. Aquí ves dónde queda y cómo llegar.' }
  ];
  var PASOS_ARENA = [
    { sel: ['[data-tcg-quiz]'], scroll: true, t: 'Adivina la carta', p: 'Un monstruo, cuatro nombres y 15 segundos. Cuanto antes aciertes, más puntos (de 4 a 1).' },
    { sel: ['[data-tcg-atk]'], scroll: true, t: 'Duelo de ATK', p: '¿El monstruo oculto pega más o menos? Un punto por acierto; diez seguidos es la racha perfecta.' },
    { sel: ['[data-tcg-retos]'], scroll: true, t: 'Retos del día', p: 'Yugidle, Adivina el set y El intruso, contra reloj. Son los que más puntos dan: Yugidle hasta 10.' },
    { sel: ['[data-tcg-wheel]'], scroll: true, t: 'La ruleta', p: 'Un giro gratis al día: suma 1 punto y puedes ganar descuentos, saldo o sobres.' },
    { sel: ['[data-tcg-rank]'], scroll: true, t: 'Ranking y premios', p: 'Mira tu puesto del mes y el general. El top 4 del mes gana crédito de la tienda: $50.000, $35.000, $25.000 y $15.000.' }
  ];

  // ── Recorrido ──────────────────────────────────────────────────────────
  var rc = null; // estado del recorrido abierto

  function destino(paso) {
    for (var i = 0; i < paso.sel.length; i++) {
      var el = document.querySelector(paso.sel[i]);
      if (visible(el)) return el;
    }
    if (paso.movil) {
      var m = document.querySelector('.header__icon--menu');
      if (visible(m)) return m;
    }
    return null;
  }

  function coloca() {
    if (!rc) return;
    var el = rc.el, hueco = rc.hueco, globo = rc.globo;
    var movil = window.matchMedia('(max-width: 749px)').matches;
    if (!el) {
      hueco.classList.add('is-centro');
      if (!movil) { globo.style.left = Math.max(12, (innerWidth - globo.offsetWidth) / 2) + 'px'; globo.style.top = Math.max(12, (innerHeight - globo.offsetHeight) / 2) + 'px'; }
      return;
    }
    hueco.classList.remove('is-centro');
    var r = el.getBoundingClientRect(), pad = 6;
    hueco.style.left = (r.left - pad) + 'px';
    hueco.style.top = (r.top - pad) + 'px';
    hueco.style.width = (r.width + pad * 2) + 'px';
    hueco.style.height = (r.height + pad * 2) + 'px';
    if (movil) return; // en móvil el globo va abajo, por CSS
    var gw = globo.offsetWidth, gh = globo.offsetHeight;
    var left = Math.min(Math.max(12, r.left + r.width / 2 - gw / 2), innerWidth - gw - 12);
    var top = r.bottom + 14;
    if (top + gh > innerHeight - 12) top = r.top - gh - 14;
    top = Math.min(Math.max(12, top), Math.max(12, innerHeight - gh - 12));
    globo.style.left = left + 'px';
    globo.style.top = top + 'px';
  }

  function muestra(i) {
    var pasos = rc.pasos;
    if (i < 0) i = 0;
    if (i >= pasos.length) { termina(true); return; }
    rc.i = i;
    var paso = pasos[i];
    var el = destino(paso);
    var movilMenu = el && el.matches && el.matches('.header__icon--menu');
    if (el && paso.scroll) el.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    rc.el = el;
    var puntos = pasos.map(function (_, k) { return '<i' + (k === i ? ' class="is-on"' : '') + '></i>'; }).join('');
    var ultimo = i === pasos.length - 1;
    rc.globo.innerHTML =
      '<button type="button" class="tcg-bv-globo__x" data-bv="salta" aria-label="Salir del recorrido">' + X_SVG + '</button>' +
      '<div class="tcg-bv-puntos" aria-hidden="true">' + puntos + '</div>' +
      '<p class="tcg-bv-globo__paso">Paso ' + (i + 1) + ' de ' + pasos.length + '</p>' +
      '<h3 id="tcg-bv-titulo">' + esc(paso.t) + '</h3>' +
      '<p id="tcg-bv-texto">' + esc(paso.p) + (movilMenu ? ' Está en el menú.' : '') + '</p>' +
      '<div class="tcg-bv-globo__nav">' +
        (i > 0 ? '<button type="button" class="tcg-bv-btn" data-bv="atras">Anterior</button>' : '') +
        '<button type="button" class="tcg-bv-btn tcg-bv-btn--fuerte" data-bv="sigue">' + (ultimo ? 'Terminar' : 'Siguiente') + '</button>' +
        '<button type="button" class="tcg-bv-globo__saltar" data-bv="salta">Saltar recorrido</button>' +
      '</div>';
    coloca();
    var foco = rc.globo.querySelector('[data-bv="sigue"]');
    if (foco) foco.focus({ preventScroll: true });
  }

  function abre(pasos, clave, alFinal) {
    if (rc) return;
    activa(true);
    var bloqueo = nodo('<div class="tcg-bv-bloqueo"></div>');
    var hueco = nodo('<div class="tcg-bv-hueco is-centro" aria-hidden="true"></div>');
    var globo = nodo('<div class="tcg-bv-globo" role="dialog" aria-modal="true" aria-labelledby="tcg-bv-titulo" aria-describedby="tcg-bv-texto"></div>');
    document.body.appendChild(bloqueo); document.body.appendChild(hueco); document.body.appendChild(globo);
    rc = { pasos: pasos, clave: clave, alFinal: alFinal, bloqueo: bloqueo, hueco: hueco, globo: globo, i: 0, el: null, previo: document.activeElement };
    globo.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bv]');
      if (!b) return;
      var a = b.getAttribute('data-bv');
      if (a === 'sigue') muestra(rc.i + 1);
      else if (a === 'atras') muestra(rc.i - 1);
      else termina(false);
    });
    bloqueo.addEventListener('click', function () { muestra(rc.i + 1); });
    muestra(0);
    requestAnimationFrame(sigueCuadro);
  }

  function termina(completo) {
    if (!rc) return;
    var r = rc; rc = null;
    if (r.clave) guarda(r.clave);
    [r.bloqueo, r.hueco, r.globo].forEach(function (n) { n.remove(); });
    activa(false);
    if (r.previo && r.previo.focus) r.previo.focus({ preventScroll: true });
    if (completo && r.alFinal) r.alFinal();
  }

  document.addEventListener('keydown', function (e) {
    if (!rc) return;
    if (e.key === 'Escape') { e.preventDefault(); termina(false); }
    else if (e.key === 'ArrowRight') muestra(rc.i + 1);
    else if (e.key === 'ArrowLeft') muestra(rc.i - 1);
    else if (e.key === 'Tab') {
      var f = rc.globo.querySelectorAll('button');
      if (!f.length) return;
      var pri = f[0], ult = f[f.length - 1];
      if (e.shiftKey && document.activeElement === pri) { e.preventDefault(); ult.focus(); }
      else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
    }
  });
  /* Mientras el recorrido está abierto, el hueco y el globo siguen al elemento en
     cada cuadro: el desplazamiento suave y la cabecera fija lo mueven, y en este
     theme el scroll no siempre llega como evento a window. */
  function sigueCuadro() { if (!rc) return; coloca(); requestAnimationFrame(sigueCuadro); }

  // ── Pase de bienvenida ─────────────────────────────────────────────────
  /* Tarjeta pequeña en una esquina (abajo en el celular): no oscurece ni bloquea
     la página y no se roba el foco. Resumen en tarjetas que se pasan con flechas,
     puntos, deslizando o con el teclado; "Saltar" y la X siempre a la vista. */
  var SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var ICONOS = {
    inicio: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8"/>',
    arena: '<path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4Z"/><path d="M17 6h3v1.5A3.5 3.5 0 0 1 16.5 11M7 6H4v1.5A3.5 3.5 0 0 0 7.5 11"/>',
    perfil: '<path d="M12 3l7 3v6c0 4.4-2.9 7.6-7 9-4.1-1.4-7-4.6-7-9V6l7-3Z"/><path d="M9 12l2 2 4-4"/>',
    comunidad: '<path d="M4 5h11v8H8.5L4 16.5V5Z"/><path d="M15 9h5v10.5L16.5 17H10v-4"/>',
    tienda: '<path d="M5 8h14l-1.2 12H6.2L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>'
  };
  var X_SVG = SVG + '<path d="M6 6l12 12M18 6L6 18"/></svg>';
  var tactil = window.matchMedia('(hover: none)').matches;
  var TARJETAS = [
    { ic: 'inicio', t: 'Te lo contamos en 30 segundos', p: 'Renovamos la tienda de arriba abajo. Pasa las tarjetas o ciérralas cuando quieras.' },
    { ic: 'arena', t: 'La Arena', p: 'Seis juegos diarios. Cada uno da puntos según su dificultad y el top 4 del mes gana crédito para gastar en la tienda.', a: { txt: 'Ir a la Arena', href: '/pages/arena' } },
    { ic: 'perfil', t: 'Tu Perfil Duelista', p: 'Rango, logros, títulos y marcos. Inicia sesión para que tus puntos y tus logros cuenten.' },
    { ic: 'comunidad', t: 'La comunidad', p: 'Foros, intercambio entre duelistas y los torneos del Rincón.' },
    { ic: 'tienda', t: 'La tienda', p: (tactil ? 'Busca cualquier carta por nombre o código' : 'Busca cualquier carta con la tecla /') + ', fichas más claras, modo oscuro y muy pronto tienda física en Medellín.' }
  ];

  function pase(o) {
    if (document.querySelector('.tcg-bv-pase')) return;
    if (o.clave) guarda(o.clave); // se muestra una sola vez aunque no se cierre
    var n = o.tarjetas.length, i = 0, uno = n === 1;
    var cartas = o.tarjetas.map(function (c, k) {
      return '<article class="tcg-bv-pase__carta" data-k="' + k + '">' +
          '<span class="tcg-bv-pase__icono">' + SVG + ICONOS[c.ic] + '</svg></span>' +
          '<div><h3>' + esc(c.t) + '</h3><p>' + esc(c.p) + '</p>' +
          (c.a ? '<a class="tcg-bv-pase__enlace" href="' + esc(c.a.href) + '">' + esc(c.a.txt) + '</a>' : '') + '</div>' +
        '</article>';
    }).join('');
    var puntos = uno ? '' : o.tarjetas.map(function (_, k) {
      return '<button type="button" data-ir="' + k + '" aria-label="Tarjeta ' + (k + 1) + ' de ' + n + '"></button>';
    }).join('');
    var p = nodo(
      '<section class="tcg-bv-pase" role="region" aria-label="' + esc(o.etiqueta) + '">' +
        '<span class="tcg-bv-pase__brillo" aria-hidden="true"></span>' +
        '<header class="tcg-bv-pase__cab">' +
          '<span class="tcg-bv-pase__medalla" aria-hidden="true">' + (LOGO ? '<img src="' + esc(LOGO) + '" alt="">' : '') + '<i></i><i></i><i></i></span>' +
          '<div><p class="tcg-bv-pase__eyebrow">' + esc(o.eyebrow) + '</p><h2 class="tcg-bv-pase__titulo">' + esc(o.titulo) + '</h2></div>' +
          '<button type="button" class="tcg-bv-pase__x" data-bv="cerrar" aria-label="Cerrar">' + X_SVG + '</button>' +
        '</header>' +
        '<div class="tcg-bv-pase__ventana" aria-live="polite">' + cartas + '</div>' +
        '<footer class="tcg-bv-pase__pie">' +
          '<button type="button" class="tcg-bv-pase__saltar" data-bv="cerrar">Saltar</button>' +
          (uno ? '' : '<div class="tcg-bv-pase__puntos">' + puntos + '</div>') +
          '<div class="tcg-bv-pase__nav">' +
            (uno ? '' : '<button type="button" class="tcg-bv-pase__atras" data-bv="atras" aria-label="Anterior">' + SVG + '<path d="M15 6l-6 6 6 6"/></svg></button>') +
            '<button type="button" class="tcg-bv-btn tcg-bv-btn--fuerte" data-bv="sigue">Siguiente</button>' +
          '</div>' +
        '</footer>' +
      '</section>');
    var els = p.querySelectorAll('.tcg-bv-pase__carta'), bPuntos = p.querySelectorAll('[data-ir]');
    var bSigue = p.querySelector('[data-bv="sigue"]'), bAtras = p.querySelector('[data-bv="atras"]'), bSaltar = p.querySelector('.tcg-bv-pase__saltar');

    function ir(k) {
      i = Math.max(0, Math.min(n - 1, k));
      for (var j = 0; j < n; j++) {
        els[j].classList.toggle('is-on', j === i);
        els[j].classList.toggle('is-antes', j < i);
        els[j].setAttribute('aria-hidden', j === i ? 'false' : 'true');
        var a = els[j].querySelector('a'); if (a) a.tabIndex = j === i ? 0 : -1;
        if (bPuntos[j]) bPuntos[j].setAttribute('aria-current', j === i ? 'true' : 'false');
      }
      var ult = i === n - 1;
      if (bAtras) bAtras.disabled = i === 0;
      bSigue.textContent = ult ? (o.final ? o.final.txt : 'Listo') : 'Siguiente';
      bSaltar.textContent = ult ? 'Cerrar' : 'Saltar';
    }
    function cierra(fn) {
      if (!p.isConnected || p.classList.contains('is-sale')) return;
      p.classList.add('is-sale');
      setTimeout(function () { p.remove(); }, 320);
      document.documentElement.classList.remove('tcg-bv-pase-on');
      activa(false);
      if (fn) fn();
    }
    p.addEventListener('click', function (e) {
      var d = e.target.closest('[data-ir]');
      if (d) { ir(+d.getAttribute('data-ir')); return; }
      var b = e.target.closest('[data-bv]');
      if (!b) return;
      var a = b.getAttribute('data-bv');
      if (a === 'atras') ir(i - 1);
      else if (a === 'sigue') { if (i < n - 1) ir(i + 1); else cierra(o.final && o.final.fn); }
      else cierra();
    });
    p.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); cierra(); }
      else if (e.key === 'ArrowRight' && !uno) ir(i + 1);
      else if (e.key === 'ArrowLeft' && !uno) ir(i - 1);
    });
    var x0 = null, ventana = p.querySelector('.tcg-bv-pase__ventana');
    ventana.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    ventana.addEventListener('pointerup', function (e) {
      if (x0 === null || uno) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) ir(i + (dx < 0 ? 1 : -1));
    });
    ir(0);
    activa(true);
    document.documentElement.classList.add('tcg-bv-pase-on');
    document.body.appendChild(p);
    requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-visible'); }); });
  }

  function bienvenida(clave) {
    pase({
      etiqueta: 'Bienvenida al nuevo Rincón',
      eyebrow: 'Bienvenido, duelista',
      titulo: 'El Rincón cambió',
      tarjetas: TARJETAS,
      clave: clave,
      final: { txt: 'Mostrarme dónde está', fn: function () { abre(PASOS_TIENDA, null, cierreTienda); } }
    });
  }

  // ── Gran bienvenida (solo el día del lanzamiento) ──────────────────────
  /* Escenario a pantalla completa: el logo cae con onda y chispas, "Bienvenido
     al nuevo Rincón" letra por letra y cinco cartas que se reparten boca abajo
     y se voltean en abanico (en el celular, fila que se desliza). "Saltar"
     está a la vista desde el primer cuadro. Quien llega del telón ve solo las
     cartas, sobre la tienda recién abierta. */
  var CARTAS_GRAN = [
    { ic: 'arena', arte: 'arena', t: 'La Arena', tipo: 'Arena / Juegos', p: 'Seis juegos diarios. Suma puntos y el top 4 del mes gana crédito en la tienda.', href: '/pages/arena', cod: 'RNC-ES001' },
    { ic: 'perfil', arte: 'perfil', t: 'Perfil Duelista', tipo: 'Perfil / Logros', p: 'Tu rango, logros, títulos y marcos. Inicia sesión para que todo cuente.', href: '/pages/perfil-duelista', cod: 'RNC-ES002' },
    { ic: 'forja', arte: 'forja', t: 'Forja tu deck', tipo: 'Forja / Decks', p: 'Arma tu deck carta por carta y lleva al carrito lo que te falta.', href: '/pages/forja', cod: 'RNC-ES003' },
    { ic: 'comunidad', arte: 'comunidad', t: 'Comunidad', tipo: 'Comunidad / Duelistas', p: 'Foros, intercambio entre duelistas y los torneos del Rincón.', href: '/pages/comunidad-del-rincon', cod: 'RNC-ES004' },
    { ic: 'tienda', arte: 'tienda', t: 'La tienda', tipo: 'Tienda / Cartas', p: 'Buscador nuevo, fichas más claras, modo oscuro y tienda física muy pronto.', href: '', cod: 'RNC-ES005' }
  ];
  function arteDe(n) { return ARTE ? ARTE.replace('tcg-bv-arte-arena', 'tcg-bv-arte-' + n) : ''; }
  ICONOS.forja = '<rect x="8" y="3.5" width="11" height="15" rx="1.5"/><path d="M5.5 6.5v12A2 2 0 0 0 7.5 20.5H16"/><path d="M11 9.5h5M11 12.5h5"/>';

  function gran(o) {
    o = o || {};
    if (document.querySelector('.tcg-bv-gran')) return;
    guarda(CLAVE);
    CARTAS_GRAN.forEach(function (c) { if (ARTE) new Image().src = arteDe(c.arte); });
    var sinIntro = !!o.sinIntro, movil = window.matchMedia('(max-width: 749px)').matches;
    var letras = 'nuevo Rincón'.split('').map(function (ch, k) {
      return ch === ' ' ? '<span class="gran__esp"> </span>' : '<span class="gran__l" style="--k:' + k + '">' + esc(ch) + '</span>';
    }).join('');
    var dorso = '<span class="gran__dorso">' + (LOGO ? '<img src="' + esc(LOGO) + '" alt="">' : '') + '</span>';
    var cartas = CARTAS_GRAN.map(function (c, k) {
      var cara =
        '<span class="gran__cara">' +
          '<span class="gran__nombre"><b>' + esc(c.t) + '</b><span class="gran__emblema">' + SVG + ICONOS[c.ic] + '</svg></span></span>' +
          '<span class="gran__arte">' + (ARTE ? '<img src="' + esc(arteDe(c.arte)) + '" alt="" decoding="async">' : '') + '<span class="gran__holo"></span></span>' +
          '<span class="gran__texto"><strong>[' + esc(c.tipo) + ']</strong>' + esc(c.p) + '</span>' +
          '<span class="gran__pie"><span>' + esc(c.cod) + '</span><span>1.ª edición</span></span>' +
        '</span>';
      var tag = c.href ? 'a href="' + esc(c.href) + '"' : 'button type="button" data-gran="cerrar"';
      return '<li class="gran__slot" style="--i:' + k + '"><' + tag + ' class="gran__carta" aria-label="' + esc(c.t + ': ' + c.p) + '">' +
        dorso + cara + '</' + (c.href ? 'a' : 'button') + '></li>';
    }).join('');
    var g = nodo(
      '<div class="tcg-bv-gran' + (sinIntro ? ' is-sin-intro' : '') + '" role="dialog" aria-modal="true" aria-label="Bienvenida al nuevo Rincón">' +
        '<span class="gran__fondo" aria-hidden="true"></span>' +
        '<span class="gran__rayos" aria-hidden="true"></span>' +
        '<span class="gran__brasas" aria-hidden="true"></span>' +
        '<button type="button" class="gran__saltar" data-gran="cerrar">Saltar' + X_SVG + '</button>' +
        '<div class="gran__cab">' +
          '<span class="gran__onda" aria-hidden="true"></span>' +
          (LOGO ? '<img class="gran__logo" src="' + esc(LOGO) + '" alt="">' : '') +
          '<p class="gran__pre">Bienvenido al</p>' +
          '<h2 class="gran__titulo"><span class="gran__palabra">' + letras + '<span class="gran__brillo" aria-hidden="true"></span></span></h2>' +
          '<p class="gran__sub">Renovamos todo. Esto es lo nuevo.</p>' +
        '</div>' +
        '<ul class="gran__mesa">' + cartas + '</ul>' +
        '<p class="gran__pista" aria-hidden="true">Desliza para ver todas</p>' +
        '<div class="gran__acciones">' +
          '<button type="button" class="tcg-bv-btn tcg-bv-btn--fuerte" data-gran="cerrar">Explorar la tienda</button>' +
          '<button type="button" class="tcg-bv-btn" data-gran="recorrido">Hacer el recorrido</button>' +
          '<a class="gran__arena" href="/pages/arena">Ir a la Arena</a>' +
        '</div>' +
      '</div>');

    var brasas = g.querySelector('.gran__brasas');
    for (var b = 0; b < (movil ? 16 : 30); b++) {
      var s = document.createElement('i');
      s.style.left = (Math.random() * 100) + '%';
      s.style.setProperty('--d', (6 + Math.random() * 7).toFixed(1) + 's');
      s.style.setProperty('--r', (-Math.random() * 12).toFixed(1) + 's');
      s.style.setProperty('--x', ((Math.random() - .5) * 120).toFixed(0) + 'px');
      brasas.appendChild(s);
    }

    var previo = document.activeElement;
    activa(true);
    document.documentElement.classList.add('tcg-bv-gran-on');
    document.body.appendChild(g);
    var saltar = g.querySelector('.gran__saltar');
    saltar.focus({ preventScroll: true });

    var timers = [];
    function luego(ms, fn) { timers.push(setTimeout(fn, ms)); }
    function fase(c) { g.classList.add(c); }
    function chispas() {
      var cab = g.querySelector('.gran__cab');
      for (var k = 0; k < (movil ? 22 : 40); k++) {
        var c = document.createElement('span');
        c.className = 'gran__chispa';
        cab.appendChild(c);
        if (!c.animate) continue;
        var a = Math.random() * Math.PI * 2, d = 90 + Math.random() * (movil ? 140 : 260);
        c.animate([{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + (Math.cos(a) * d).toFixed(0) + 'px), calc(-50% + ' + (Math.sin(a) * d * .7).toFixed(0) + 'px)) scale(.2)', opacity: 0 }],
          { duration: 700 + Math.random() * 700, easing: 'cubic-bezier(.1,.7,.3,1)', fill: 'forwards' });
      }
    }

    if (reduce) { fase('is-listo'); }
    else if (sinIntro) {
      requestAnimationFrame(function () { fase('is-in'); });
      luego(300, function () { fase('is-reparte'); });
      luego(300 + 5 * 160 + 900, function () { fase('is-listo'); });
    } else {
      requestAnimationFrame(function () { fase('is-in'); });
      luego(420, function () { fase('is-golpe'); chispas(); });
      luego(900, function () { fase('is-texto'); });
      luego(2700, function () { fase('is-sube'); });
      luego(3100, function () { fase('is-reparte'); });
      luego(3100 + 5 * 160 + 900, function () { fase('is-listo'); });
    }

    function cierra(fn) {
      if (!g.isConnected || g.classList.contains('is-sale')) return;
      timers.forEach(clearTimeout);
      document.removeEventListener('keydown', teclas, true);
      g.classList.add('is-sale');
      setTimeout(function () { g.remove(); }, 450);
      document.documentElement.classList.remove('tcg-bv-gran-on');
      activa(false);
      if (previo && previo.focus) previo.focus({ preventScroll: true });
      if (fn) fn();
    }
    function teclas(e) {
      if (e.key === 'Escape') { e.preventDefault(); cierra(); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(g.querySelectorAll('a, button'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var pri = f[0], ult = f[f.length - 1];
      if (e.shiftKey && document.activeElement === pri) { e.preventDefault(); ult.focus(); }
      else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
    }
    document.addEventListener('keydown', teclas, true);
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gran]');
      if (!b) return;
      if (b.getAttribute('data-gran') === 'recorrido') cierra(function () { abre(PASOS_TIENDA, null, cierreTienda); });
      else cierra();
    });
  }

  // ── Final del recorrido de la tienda ───────────────────────────────────
  function cierreTienda() {
    pase({
      etiqueta: 'Fin del recorrido',
      eyebrow: 'Listo',
      titulo: 'Ya conoces el Rincón',
      tarjetas: [{ ic: 'arena', t: 'Juega hoy en la Arena', p: 'Cada partida suma para el ranking del mes. Repite el recorrido cuando quieras desde el pie de página.', a: { txt: 'Ir a la Arena', href: '/pages/arena' } }]
    });
  }

  /* Telón del cambio de theme: el theme viejo lo dejó cerrado y el <head>
     (snippets/tcg-bienvenida.liquid) lo pintó igual en el primer cuadro.
     Aquí se cambia por el telón animado y se abre sobre la tienda nueva. */
  function remate(efecto, alFin) {
    var raiz = document.documentElement;
    if (reduce || efecto !== 'telon') { raiz.classList.remove('tcg-bv-cortina'); alFin(); return; }
    activa(true);
    var capa = nodo(
      '<div class="tcg-bv-remate" aria-hidden="true">' +
        '<span class="tl-cortina tl-cortina--izq"></span><span class="tl-cortina tl-cortina--der"></span>' +
        '<span class="tl-amarre tl-amarre--izq"></span><span class="tl-amarre tl-amarre--der"></span>' +
        '<span class="tl-bambalina"></span>' +
        '<span class="tl-foco tl-foco--a"></span><span class="tl-foco tl-foco--b"></span>' +
        '<span class="tl-costura"></span><span class="tl-medalla"></span><span class="tl-onda"></span>' +
      '</div>');
    document.body.appendChild(capa);
    raiz.classList.remove('tcg-bv-cortina');
    function paso(ms, clase) { setTimeout(function () { capa.classList.add(clase); }, ms); }
    paso(250, 'is-estalla');
    setTimeout(confeti, 450);
    paso(450, 'is-abre');
    paso(1500, 'is-amarra');
    paso(1300, 'is-sube');
    paso(2500, 'is-fuera');
    setTimeout(function () { capa.remove(); alFin(); }, 3300);
  }

  function confeti() {
    var cont = document.createElement('div');
    cont.className = 'tcg-bv-confeti';
    cont.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cont);
    var colores = ['#E2B45C', '#C4923B', '#fff3c8', '#F3EFE6', '#9A2418'];
    var n = innerWidth < 600 ? 55 : 100, alto = innerHeight + 60;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span'), w = 6 + Math.random() * 8;
      p.style.left = (Math.random() * 100) + '%';
      p.style.width = w + 'px';
      p.style.height = (w * .45) + 'px';
      p.style.background = colores[i % colores.length];
      cont.appendChild(p);
      if (!p.animate) continue;
      p.animate([
        { transform: 'translate3d(0,0,0) rotate3d(1,.4,0,0deg)' },
        { transform: 'translate3d(' + ((Math.random() - .5) * 220) + 'px,' + alto + 'px,0) rotate3d(1,.4,0,' + (540 + Math.random() * 720) + 'deg)' }
      ], { duration: 2200 + Math.random() * 1600, delay: Math.random() * 600, easing: 'cubic-bezier(.25,.55,.45,1)', fill: 'forwards' });
    }
    setTimeout(function () { cont.remove(); }, 4600);
  }

  function avisoArena() {
    if (document.querySelector('.tcg-bv-pase')) return;
    var a = nodo(
      '<div class="tcg-bv-aviso" role="region" aria-label="Recorrido de la Arena">' +
        '<p>¿Primera vez en la Arena? Te mostramos cómo se suman los puntos en cinco pasos.</p>' +
        '<button type="button" class="tcg-bv-btn tcg-bv-btn--fuerte" data-bv="si">Ver cómo funciona</button>' +
        '<button type="button" class="tcg-bv-btn" data-bv="no">No, gracias</button>' +
      '</div>');
    document.body.appendChild(a);
    requestAnimationFrame(function () { a.classList.add('is-visible'); });
    a.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bv]');
      if (!b) return;
      a.remove();
      if (b.getAttribute('data-bv') === 'si') abre(PASOS_ARENA, CLAVE_ARENA);
      else guarda(CLAVE_ARENA);
    });
  }

  // ── Arranque ───────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tcg-recorrido]');
    if (!b) return;
    e.preventDefault();
    if (EN_ARENA) abre(PASOS_ARENA, null); else bienvenida(null);
  });

  /* Día del lanzamiento (21 de octubre, hora de Bogotá): gran bienvenida.
     Del 22 al 26: el pase pequeño. Desde el 27 ya no sale solo (el pie lo abre). */
  var FIN_GRAN = Date.parse('2026-10-22T00:00:00-05:00'), FIN_PASE = Date.parse('2026-10-27T00:00:00-05:00');
  function etapaBienvenida() {
    var ahora = Date.now();
    return ahora < FIN_GRAN ? 'gran' : ahora < FIN_PASE ? 'pase' : '';
  }

  function arranca() {
    var desdeCambio = /[?&]bienvenida=1/.test(location.search);
    var efecto = (/[?&]efecto=([a-z]+)/.exec(location.search) || [])[1] || '';
    if (desdeCambio && history.replaceState) {
      var limpio = location.search.replace(/[?&](bienvenida|efecto)=[^&]*/g, '').replace(/^&/, '?');
      history.replaceState(null, '', location.pathname + (limpio === '?' ? '' : limpio) + location.hash);
    }
    /* Para probar: ?tcg_bienvenida=gran | pase (sin importar fecha ni si ya se vio). */
    var forzado = (/[?&]tcg_bienvenida=(gran|pase)/.exec(location.search) || [])[1];
    if (forzado === 'gran') { gran(); return; }
    if (forzado === 'pase') { bienvenida(null); return; }
    var etapa = etapaBienvenida();
    if (desdeCambio) { remate(efecto, function () { if (!lee(CLAVE)) { if (etapa === 'gran') gran({ sinIntro: true }); else if (etapa === 'pase') bienvenida(CLAVE); } }); return; }
    if (!lee(CLAVE) && etapa === 'gran') { setTimeout(gran, 500); return; }
    if (!lee(CLAVE) && etapa === 'pase') { setTimeout(function () { bienvenida(CLAVE); }, 1200); return; }
    if (EN_ARENA && !lee(CLAVE_ARENA)) setTimeout(avisoArena, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
})();
